import React from "react";
import classNames from "classnames";
import withTranslations from "../../../../../hocs/withTranslations";
import {
  getNameDisplayValue,
  shouldRenderNameDash
} from "../../../../../lib/UniversalTable/RendererHelpers/NameHelper";
import "../rendererStyles/String.scss";

const Name = ({ value, format, translate, columnFontSize, resultMetaData }) => {
  const displayValue = getNameDisplayValue(value, resultMetaData);

  return (
    <div
      className={classNames({
        "string-renderer": true,
        [`column-size-${columnFontSize}`]: !!columnFontSize
      })}
    >
      {format === "string_translated"
        ? translate(displayValue)
        : displayValue}
    </div>
  );
};

Name.shouldRenderDash = shouldRenderNameDash;

export default withTranslations(Name);
